import { AppBar, Box, Divider, Toolbar, useTheme } from "@mui/material"

export interface IHeaderProps {
  logo?: React.ReactElement
  title?: React.ReactElement
  backButton?: React.ReactElement
  clock?: React.ReactElement
  languageButton?: React.ReactElement
  searchButton?: React.ReactElement
  shareButton?: React.ReactElement
}

export const Header: React.FC<IHeaderProps> = ({
  logo,
  title,
  backButton,
  clock,
  languageButton,
  searchButton,
  shareButton,
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppHeader`]?.styleOverrides || {}
  const {
    root,
    toolbar,
    clockContainer,
    backButtonContainer,
    logoContainer,
    titleContainer,
    line,
    languangeContainer,
    searchContainer,
    shareContainer,
  } = styleOverrides

  return (
    <AppBar className="AppHeader-root" component="nav" sx={root}>
      <Toolbar className="AppHeader-toolbar" sx={toolbar}>
        {backButton && (
          <Box className="AppHeader-backbutton" sx={backButtonContainer}>
            {backButton}
          </Box>
        )}
        {logo && (
          <Box className="AppHeader-logo" sx={logoContainer}>
            {logo}
          </Box>
        )}
        {title && (
          <Box className="AppHeader-title" sx={titleContainer}>
            {title}
          </Box>
        )}
        {clock && (
          <Box className="AppHeader-clock" sx={clockContainer}>
            {clock}
          </Box>
        )}
        {searchButton && (
          <Box className="AppHeader-search" sx={searchContainer}>
            {searchButton}
          </Box>
        )}
        {languageButton && (
          <Box className="AppHeader-language" sx={languangeContainer}>
            {languageButton}
          </Box>
        )}
        {shareButton && (
          <Box className="AppHeader-share" sx={shareContainer}>
            {shareButton}
          </Box>
        )}
      </Toolbar>
      <Divider className="AppHeader-line" sx={line} />
    </AppBar>
  )
}
